module.exports = __webpack_public_path__ + "supermarkets.b3f1da70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/retailers/supermarkets.png
// module id = 1746
// module chunks = 0